import React from 'react';
import { useLocation } from '@reach/router';
import { BoxProps, Box, Paragraph, SubTitle } from '@themed';
import { useTranslate } from '@modules';
import { CTAWithOptionalLink, SvgIcon } from '@core';
import { getTypeFromPath } from '@config';
import { styles } from './ReportAdvertLink.styles';

interface Props extends BoxProps {}

export default ({
  sx, ...props
}: Props) => {
  const __ = useTranslate();
  const { pathname } = useLocation();
  const titlePrefix = `finnoscore.${getTypeFromPath(pathname)}.ranking`;
  return (
    <Box {...props} sx={{ ...styles.box, ...sx }}>
      <SubTitle sx={styles.title}>{__(`${titlePrefix}.title`)}</SubTitle>
      {(__(`${titlePrefix}.text`, true) || __(`${titlePrefix}.link`, true)) && (
        <Paragraph sx={styles.paragraph}>
          {__(`${titlePrefix}.text`, true) && __(`${titlePrefix}.text`)}
          {__(`${titlePrefix}.link`, true) && (
            <CTAWithOptionalLink to={__(`${titlePrefix}.link`)} sx={styles.cta}>
              <span className="text">{__(`${titlePrefix}.buttonText`)}</span>
              <SvgIcon name="tailedArrow" />
            </CTAWithOptionalLink>
          )}
        </Paragraph>)}
    </Box>
  );
};
